export enum Permissions {
  company_create,
  company_read,
  offer_create,
  offer_delete,
  offer_read,
  partner_create,
  partner_read,
  proposal_create,
  proposal_delete,
  proposal_read,
  terms_conditions_create,
  terms_conditions_read,
  user_read,
  read_kis_api
}
